export default {"src":"/_next/static/media/vpbank-logo.9a075017.svg","height":64,"width":196};